import { render, staticRenderFns } from "./otx.vue?vue&type=template&id=8ddf7b2c&scoped=true"
import script from "./otx.vue?vue&type=script&lang=js"
export * from "./otx.vue?vue&type=script&lang=js"
import style0 from "./otx.vue?vue&type=style&index=0&id=8ddf7b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddf7b2c",
  null
  
)

export default component.exports